import { configureStore } from '@reduxjs/toolkit'
import RouteSlice from './Feature/RouteSlice'

export const store = configureStore({
  reducer: {
    route: RouteSlice
  },
})

export default store
